import Avatar from '@material-ui/core/Avatar';
import React, { useState, useEffect } from 'react';
import * as md5 from 'md5';

interface Props {
    email: string;
    className?: string;
}

function TimelineEventAvatar(props: Props) {
    const { email, className } = props;
    const [emailHash, setEmailHash] = useState(md5(email.toLowerCase()));

    useEffect(() => {
        setEmailHash(md5(email.toLowerCase()));
    }, [email]);

    return (
        <Avatar className={className} alt={email} src={`https://secure.gravatar.com/avatar/${emailHash}?s=80&d=identicon`} />
    );
};

export default TimelineEventAvatar;
